 //获取url或hash并解码
export default function getDecodeUrl(url) {
    if(url) {
        return decodeURIComponent(url);
    }
    return decodeURIComponent(location.hash);
}